export class CableDetails {
  gridElementId: number;
  sourceGridElementName: string;
  endGridElementName: string;
  length: number;
  type: string;
  resistance: number;
  reactance: number;
  capacitanceC1uFKm: number;
  isOverhead: boolean;
  isUnderground: boolean;
  maxCurrent: number;

  constructor(gridElementId: number, sourceGridElementName: string, endGridElementName: string, length: number, type: string,
              resistance: number, reactance: number, capacitanceC1uFKm: number, isOverhead: boolean, isUnderground: boolean,
              maxCurrent: number) {
    this.gridElementId = gridElementId;
    this.sourceGridElementName = sourceGridElementName;
    this.endGridElementName = endGridElementName;
    this.length = length;
    this.type = type;
    this.resistance = resistance;
    this.reactance = reactance;
    this.capacitanceC1uFKm = capacitanceC1uFKm;
    this.isOverhead = isOverhead;
    this.isUnderground = isUnderground;
    this.maxCurrent = maxCurrent;
  }

  getPosition(): string {
    if (this.isOverhead) {
      return "Overhead line";
    } else if (this.isUnderground) {
      return "Earth cable";
    }
  }
}
